import { useEffect } from "react";
import { useTranslation } from "../i18n";
import { useAppSelector } from "../redux/hooks";
import { useResolvedTenant } from "./useResolvedTenant";

export function usePageTitle(
  title: string | undefined,
  usePrefix: boolean = true,
): void {
  const { language } = useTranslation();
  const { data: company } = useResolvedTenant();
  const dashboardCompany = useAppSelector((state) => state.company);
  const companyName =
    (language === "ar" ? company?.nameAr : company?.name)?.trim() ||
    (language === "ar" ? dashboardCompany.nameAr : dashboardCompany.name)?.trim() ||
    company?.name?.trim() ||
    dashboardCompany.name.trim() ||
    undefined;

  useEffect(() => {
    if (!title) return;

    const previousTitle = document.title;
    const fullTitle =
      usePrefix && companyName && !title.includes(companyName)
        ? `${title} - ${companyName}`
        : title;

    document.title = fullTitle;

    return () => {
      document.title = previousTitle;
    };
  }, [title, usePrefix, companyName]);
}
